module.exports = __webpack_public_path__ + "static/media/icon.d9fae940005cee547b5ea60108d428d8.svg";